import { ProjectIcon } from "src/app/config/icon";

export enum CommonIcon {
    cancel = 'cancel',
    undo = 'undo',
    login = 'login',
    logout = 'logout',
    home = 'home',
    chevronUp = "chevron-up",
    chevronDown = "chevron-down",
    chevronLeft = "chevron-left",
    chevronRight = "chevron-right",
    account = "account",
    accountCircle = "account-circle",
    accountGroup = "account-group",
    accountCheck = "account-check",
    accountCog = "account-cog",
    arrowLeft = "arrow-left",
    arrowRight = "arrow-right",
    security = 'security',
    shieldCheck = 'shield-check',
    accountHearth = 'account-heart',
    beaker = 'beaker',
    diabetes = 'diabetes',
    hearthPulse = 'heart-pulse',
    hospitalBox = 'hospital-box',
    stethoscope = 'stethoscope',
    tongue = 'tongue',
    qrcode = 'qrcode',
    qrcodeScan = 'qrcode-scan',
    clockTimeThree = 'clock-time-three',
    clockTimeTwelve = 'clock-time-twelve',
    check = 'check',
    robot = 'robot',
    microscope = 'microscope',
    police = 'police',
    faceAgent = 'face-agent',
    trashCan = 'trash-can',
    message = 'message',
    send = 'send',
    reload = 'reload',
    reloadAlert = 'reload-alert',
    file = 'file',
    waveform = 'waveform',
    delete = 'delete',
    deleteSelectedItems = 'delete-selected-items',
    save = 'save',
    emailSend = 'email-send',
    cog = 'cog',
    gate = 'gate',
    parking = 'parking',
    gasStation = 'gas-station',
    mapMarker = 'map-marker',
    foodForkDrink = 'food-fork-drink',
    genderMale = 'gender-male',
    genderFemale = 'gender-female',
    trafficLight = 'traffic-light',
    carWash = 'car-wash',
    vectorPoint = 'vector-point',
    vectorPolygon = 'vector-polygon',
    forum = 'forum',
    messageText = 'message-text',
    dashboard = 'dashboard',
    barChart = 'bar-chart',
    download = 'download',
    keyChain = 'key-chain',
    vote = 'vote',
    music = 'music',
    microphoneVariant = 'microphone-variant',
    closeOctagon = 'close-octagon',
    close = 'close',
    informationOutline = 'information-outline',
    pencil = 'pencil',
    plusCircle = 'plus-circle',
    fileUpload = 'file-upload',
    fileDownload = 'file-download',
    fileDownloadSelectedItems = 'file-download-selected-items',
    plus = 'plus',
    fileCheck = 'file-check',
    dotsVert = 'dots-vert',
    dotsHorizontal = 'dots-horizontal',
    backupRestore = 'backup-restore',
    checkDecagram = 'check-decagram',
    at = 'at',
    instagram = 'instagram',
    phone = 'phone',
    cardAccountDetails = 'card-account-details',
    shieldAccount = 'shield-account',
    eye = 'eye',
    bug = 'bug',
    closeCircle = 'close-circle',
    checkCircle = 'check-circle',
    paperclip = 'paperclip',
    alertCircleOutline = 'alert-circle-outline',
    lov = 'lov'
}

export const Icon = { ...CommonIcon, ...ProjectIcon };

export type Icon = typeof Icon;
